import type { ShopItem } from '@/types/game';

export const SHOP_WEAPONS: readonly ShopItem[] = [
  {
    id: 'daga_elfica',
    name: 'Sartén',
    dmg: 2,
    cost: 45,
    loc: 'comarca',
    desc: 'Lo último que Sam dejaría atrás',
    bonusVs: { bestia: 0.1 },
  },
  {
    id: 'dardo',
    name: 'Dardo',
    dmg: 10,
    cost: 135,
    loc: 'bree',
    desc: 'La espada de Bilbo',
    bonusVs: { orco: 0.2, bestia: 0.3 },
  },
  {
    id: 'espada_trancos',
    name: 'Espada Dúnedain',
    dmg: 14,
    cost: 260,
    loc: 'bree',
    desc: 'Hoja gastada del Montaraz',
    bonusVs: { humano: 0.3, espectro: 0.2 },
  },
  {
    id: 'hadhafang',
    name: 'Hadhafang',
    dmg: 20,
    cost: 520,
    loc: 'rivendel',
    desc: 'Espada élfica de Arwen',
    bonusVs: { orco: 0.45, troll: 0.25, uruk_hai: 0.2 },
  },
  {
    id: 'hacha_gimli',
    name: 'Hacha de Gimli',
    dmg: 30,
    cost: 1050,
    loc: 'rivendel',
    desc: 'Hacha del enano de la Comunidad',
    bonusVs: { troll: 0.35, orco: 0.25, espectro: 0.2 },
  },
  {
    id: 'arco_galad',
    name: 'Arco Galadhrim',
    dmg: 24,
    cost: 840,
    loc: 'lothlorien',
    desc: 'Regalo de Lórien',
    bonusVs: { bestia: 0.35, uruk_hai: 0.25 },
  },
  {
    id: 'herugrim',
    name: 'Herugrim',
    dmg: 34,
    cost: 1450,
    loc: 'edoras',
    desc: 'Espada de Théoden',
    bonusVs: { uruk_hai: 0.35, bestia: 0.25 },
  },
  {
    id: 'lanza_rohirrim',
    name: 'Lanza Rohirrim',
    dmg: 29,
    cost: 1180,
    loc: 'edoras',
    desc: 'Carga de los jinetes',
    bonusVs: { bestia: 0.45, humano: 0.2 },
  },
  {
    id: 'narsil',
    name: 'Narsil Reforjada',
    dmg: 50,
    cost: 2950,
    loc: 'minas_tirith',
    bonusVs: { mordor: 0.4, espectro: 0.25 },
  },
  {
    id: 'daga_morgul',
    name: 'Daga de Morgul',
    dmg: 44,
    cost: 2600,
    loc: 'ithilien',
    desc: 'Hoja corrupta de los Nazgûl',
    bonusVs: { humano: 0.45, espectro: 0.2 },
  },
  {
    id: 'sting',
    name: 'Dardo Azul',
    dmg: 42,
    cost: 2300,
    loc: 'minas_tirith',
    desc: 'Brilla cerca de orcos',
    bonusVs: { orco: 0.55, mordor: 0.45, bestia: 0.25 },
  },
];

export const SHOP_ARMOR: readonly ShopItem[] = [
  {
    id: 'capa_elfica',
    name: 'Capa Élfica',
    def: 5,
    cost: 80,
    loc: 'lothlorien',
    bonusVs: { humano: 0.2, orco: 0.15 },
  },
  {
    id: 'mithril_coat',
    name: 'Cota de Mithril',
    def: 20,
    cost: 1550,
    loc: 'rivendel',
    desc: 'Ligera como pluma, dura como escama de dragón',
    bonusVs: { orco: 0.2, troll: 0.25, bestia: 0.15 },
  },
  {
    id: 'armadura_rohan',
    name: 'Armadura de Rohan',
    def: 14,
    cost: 980,
    loc: 'edoras',
    bonusVs: { uruk_hai: 0.25, bestia: 0.2 },
  },
  {
    id: 'yelmo_eomer',
    name: 'Yelmo de Éomer',
    def: 12,
    cost: 760,
    loc: 'campamento_rohan',
    desc: 'Forjado para resistir la carga',
    bonusVs: { humano: 0.25, bestia: 0.2 },
  },
  {
    id: 'armadura_gondor',
    name: 'Armadura de Gondor',
    def: 18,
    cost: 1400,
    loc: 'minas_tirith',
    bonusVs: { mordor: 0.3, troll: 0.2 },
  },
  {
    id: 'armadura_negra',
    name: 'Armadura de los Muertos',
    def: 26,
    cost: 3350,
    loc: 'ithilien',
    bonusVs: { espectro: 0.35 },
  },
];

export const SHOP_ACCESS: readonly ShopItem[] = [
  {
    id: 'pipa_fumar',
    name: 'Pipa de Fumar',
    bonus: 0,
    cost: 60,
    loc: 'comarca',
    desc: 'Hierba de la Comarca, calma y concentración',
    goldPct: 0.05,
  },
  {
    id: 'phial',
    name: 'Luz de Galadriel',
    bonus: 9,
    cost: 420,
    loc: 'lothlorien',
    desc: 'Luz en la oscuridad',
    bonusVs: { espectro: 0.45, criatura_antigua: 0.25 },
  },
  {
    id: 'estrella_tarde',
    name: 'Estrella de la Tarde',
    bonus: 11,
    cost: 720,
    loc: 'rivendel',
    desc: 'Joya de Arwen, símbolo de esperanza',
    bonusVs: { espectro: 0.25, mordor: 0.2 },
  },
  {
    id: 'lembas',
    name: 'Lembas',
    bonus: 15,
    cost: 1350,
    loc: 'lothlorien',
    desc: 'Pan élfico que sustenta hasta Mordor',
    bonusVs: { mordor: 0.25, espectro: 0.25, orco: 0.2 },
  },
  {
    id: 'palantir',
    name: 'Palantír',
    bonus: 20,
    cost: 2250,
    loc: 'campamento_rohan',
    bonusVs: { humano: 0.3, mordor: 0.25 },
  },
  {
    id: 'cuerno_gondor',
    name: 'Cuerno de Gondor',
    bonus: 26,
    cost: 3200,
    loc: 'ithilien',
    desc: 'La llamada de Boromir',
    bonusVs: { mordor: 0.3, uruk_hai: 0.3 },
  },
  {
    id: 'estandarte_rey',
    name: 'Estandarte del Rey',
    bonus: 24,
    cost: 2900,
    loc: 'minas_tirith',
    desc: 'El retorno del rey',
    bonusVs: { mordor: 0.35, humano: 0.2 },
  },
];
